import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle, KeyRound } from 'lucide-react';
import { motion } from 'framer-motion';
import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function OlvideContrasena() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [enviado, setEnviado] = useState(false);
    const navigate = useNavigate();
    const [params] = useSearchParams();

    // Permite volver al login correcto según desde dónde se llegó
    const origen = params.get('origen') === 'admin' ? '/admin/login' : '/login';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post(`${BASE}/api/v1/auth/password-reset/`, { email: email.trim().toLowerCase() });
        } catch {
            // El backend responde igual exista o no la cuenta; un error de red
            // tampoco debería revelar nada, así que mostramos el mismo mensaje.
        } finally {
            setLoading(false);
            setEnviado(true);
        }
    };

    return (
        <div className="pantalla-centrada">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="w-full max-w-md"
            >
                <button
                    onClick={() => navigate(origen)}
                    className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700 mb-6 transition-colors"
                >
                    <ArrowLeft size={15} /> Volver al login
                </button>

                <div className="bg-white rounded-3xl shadow-xl p-8">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="bg-brand-100 p-3 rounded-2xl">
                            <KeyRound size={24} className="text-brand-800" />
                        </div>
                        <div>
                            <h1 className="text-xl font-black text-slate-900 tracking-tight">Recuperar contraseña</h1>
                            <p className="text-xs text-slate-500 font-medium">Te enviamos un link por correo</p>
                        </div>
                    </div>

                    {enviado ? (
                        <div className="text-center space-y-4">
                            <div className="bg-exito-50 border border-exito-200 rounded-2xl p-6">
                                <CheckCircle size={32} className="text-exito-500 mx-auto mb-3" />
                                <p className="font-black text-exito-800">Revisá tu correo</p>
                                <p className="text-sm text-exito-700 mt-2">
                                    Si <strong>{email}</strong> está registrado, vas a recibir un link para
                                    definir una contraseña nueva. Vence en 1 hora.
                                </p>
                            </div>
                            <p className="text-xs text-slate-500">
                                ¿No te llegó? Revisá la carpeta de correo no deseado, o
                                <button
                                    onClick={() => setEnviado(false)}
                                    className="text-brand-800 hover:text-brand-800 font-semibold ml-1"
                                >
                                    probá con otro correo
                                </button>
                            </p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-5">
                            <p className="text-sm text-slate-600">
                                Ingresá el correo de tu cuenta y te mandamos un link para definir una contraseña nueva.
                            </p>

                            <div>
                                <label htmlFor="recuperar-correo" className="etiqueta-simple">Correo electrónico</label>
                                <div className="relative">
                                    <div className="icono-campo-interno">
                                        <Mail size={18} />
                                    </div>
                                    <input id="recuperar-correo"
                                        required
                                        type="email"
                                        autoComplete="email"
                                        className="block w-full pl-10 pr-3 py-3 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand-500 bg-slate-50 font-medium transition-colors"
                                        placeholder="tucorreo@ejemplo.com"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                    />
                                </div>
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full flex justify-center py-3 px-4 rounded-xl shadow-lg shadow-brand-500/30 font-semibold text-negro-950 bg-brand-600 hover:bg-brand-500 disabled:opacity-50 transition-all"
                            >
                                {loading ? 'Enviando...' : 'Enviar link de recuperación'}
                            </button>
                        </form>
                    )}
                </div>
            </motion.div>
        </div>
    );
}
